import { PMNDemande_Statut, PMNDemande_Statut_ToText } from '@/domain/PMNDemande_Statut'
import Vue from 'vue'

export default Vue.extend({
    methods: {
        formatDate(date: string) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        formatStatut(statut: PMNDemande_Statut) {
            return PMNDemande_Statut_ToText(statut)
        },
        isEnCoursDeRedaction(statut: PMNDemande_Statut) {
            return statut == PMNDemande_Statut.EnCoursRedaction
        },
        getColor(statut: PMNDemande_Statut) {
            switch (statut) {
                case PMNDemande_Statut.EnCoursRedaction:
                    return 'secondary'
                case PMNDemande_Statut.Envoyee:
                    return 'blue'
                case PMNDemande_Statut.EnCoursDeTraitement:
                    return 'orange'
                case PMNDemande_Statut.Refusee:
                    return 'red'
                case PMNDemande_Statut.Acceptee:
                    return 'success'
            }
        }
    }
})
